import { useMemo } from "react";
import { useSelector } from "react-redux";

import { useGetSubIndustriesDataQuery } from "../../../store/Company/companyApiSlice";

/* Turning a company's `sub_industry` ids into names — F-107. */

/* Keyed by id, so a card can resolve without scanning 614 rows per row. */
export const subIndustryMap = (rows = []) => {
  const map = new Map();
  (rows || []).forEach((row) => {
    if (row?.id != null) map.set(String(row.id), row.sub_industry);
  });
  return map;
};

export const useSubIndustryNames = () => {
  const token = useSelector((state) => state.auth?.token);
  /* The endpoint is AllowAny with no authentication_classes, so it answers a
     logged-out visitor too — the search results use this card as well. */
  const { data } = useGetSubIndustriesDataQuery({ token });

  return useMemo(() => subIndustryMap(data?.data || data), [data]);
};

export default useSubIndustryNames;
